<template>
  <div class="info-panel">
    <!-- looks for the id so it only mounts when the data is available -->
    <RoomInfo v-if="infoType === 'room'"/>
    <JumpSpaceInfo v-else-if="infoType === 'jump-space'"/>
    <div v-else-if="getLoadingSpace">
      <Skeleton size="80% 22px" margin="5px 0 45px" rounded-sm shimmer/>
      <Skeleton size="100% 40px" margin="10px 0" rounded-full shimmer/>
      <Skeleton size="100% 40px" margin="10px 0" rounded-full shimmer/>
      <Skeleton size="100% 40px" margin="30px 0" rounded-full shimmer/>
    </div>
    <space-info v-else />
  </div>
</template>

<script>
import SpaceInfo from './SpaceInfo.vue'
import RoomInfo from './RoomInfo.vue'
import JumpSpaceInfo from './JumpSpaceInfo.vue'
import Skeleton from '../../global/loading/Skeleton.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'info-panel',
  components: { SpaceInfo, RoomInfo, JumpSpaceInfo, Skeleton },
  computed: {
    ...mapGetters(['getCurrentSpacePageData', 'getLoadingSpace', 'getSpaceIfPortal']),
    infoType() {
      return this.getCurrentSpacePageData?.id ? `${this.getSpaceIfPortal ? 'jump-space' : 'room'}` : 'space'
    },
  }
}
</script>

<style scoped lang="scss">
.info-panel {
  position: relative;
}
</style>
